<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-alert
          v-if="valorTurno > 0"
          color="info"
          dark
          prominent
          class="mb-4"
          border="left"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="d-flex align-center">
                <v-icon large class="mr-3">mdi-information</v-icon>
                <div>
                  <div class="text-h6 font-weight-bold mb-1">
                    Valor de reserva: ${{ valorTurno.toFixed(2) }}
                  </div>
                  <div class="text-body-2">
                    Este monto es en concepto de reserva del turno. El saldo
                    restante deberá abonarse en el complejo.
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-alert>

        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-select
              :items="profs"
              item-text="nombre"
              item-value="idCancha"
              menu-props="auto"
              label="Cancha"
              hide-details
              prepend-icon="mdi-soccer-field"
              v-model="prof"
              :disabled="isLoading"
              class="ml-4"
              ref="vselect"
              no-data-text="No hay canchas registradas"
              @change="onCanchaChange"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="text-right d-flex align-center justify-end"
          >
            <v-btn
              color="primary"
              outlined
              @click="mostrarInfoComplejo"
              class="mr-4"
            >
              <v-icon left>mdi-information</v-icon>
              Información del Complejo
            </v-btn>
          </v-col>
        </v-row>

        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-4"
        ></v-progress-linear>

        <v-alert
          v-if="sinTurnos && !loading"
          color="orange"
          dark
          prominent
          icon="mdi-calendar-remove"
          class="mb-4"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">Cancha sin turnos disponibles</div>
              <div>
                No hay turnos disponibles en los próximos 3 meses para esta
                cancha.
              </div>
            </v-col>
          </v-row>
        </v-alert>

        <v-toolbar
          v-if="!sinTurnos"
          flat
          color="grey lighten-4"
          class="mb-4 rounded toolbar-responsive"
        >
          <v-btn
            icon
            color="primary"
            @click="retrocederSemana"
            :disabled="!puedeRetroceder || loading"
            small
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-chip
                color="primary"
                dark
                v-on="on"
                class="px-3 px-sm-6 date-chip"
              >
                <v-icon left small class="d-none d-sm-flex"
                  >mdi-calendar</v-icon
                >
                <span class="date-text">{{ dateFormatted }}</span>
              </v-chip>
            </template>

            <v-date-picker
              v-model="date"
              @input="menu = false"
              locale="es-ar"
              :first-day-of-week="1"
              @change="cargarTurnos"
              :allowed-dates="allowedDates"
              :min="fechaMinima"
              :max="fechaMaxima"
              color="primary"
            ></v-date-picker>
          </v-menu>

          <v-spacer></v-spacer>

          <v-btn
            icon
            color="success"
            @click="cargarTurnos"
            :disabled="loading"
            small
            class="mr-2"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>

          <v-btn
            icon
            color="primary"
            @click="avanzarSemana"
            :disabled="date >= fechaMaxima || loading"
            small
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>

        <v-row v-if="!sinTurnos && !loading">
          <v-col
            v-for="(turnos, dia) in turnosPorDia"
            :key="dia"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card elevation="3" class="day-card" hover>
              <v-card-title class="primary white--text py-3">
                <v-icon left dark>mdi-calendar-today</v-icon>
                <div>
                  <div class="text-subtitle-1">{{ getDiaSemana(dia) }}</div>
                  <div class="text-caption">{{ dia }}</div>
                </div>
              </v-card-title>

              <v-card-text class="pa-2">
                <v-chip-group column>
                  <v-chip
                    v-for="turno in turnos"
                    :key="turno.id"
                    color="success"
                    outlined
                    class="ma-1 time-chip"
                    @click="seleccionarTurno(turno)"
                  >
                    <v-icon left small>mdi-clock-outline</v-icon>
                    {{ turno.hora }}
                  </v-chip>
                </v-chip-group>

                <v-alert
                  v-if="turnos.length === 0"
                  color="grey"
                  text
                  dense
                  class="ma-2"
                >
                  Sin turnos disponibles
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Diálogo de información del complejo -->
    <v-dialog v-model="dialogInfo" max-width="600px" scrollable>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-icon large class="mr-2">mdi-domain</v-icon>
          <v-toolbar-title class="text-h5"
            >Información del Complejo</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogInfo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-progress-linear
          v-if="cargandoInfo"
          indeterminate
          color="primary"
        ></v-progress-linear>

        <v-card-text class="pt-6" v-if="!cargandoInfo && infoComplejo">
          <!-- Mapa de Google -->
          <div
            v-if="infoComplejo.latitud && infoComplejo.longitud"
            class="mb-4"
          >
            <GmapMap
              :center="{
                lat: infoComplejo.latitud,
                lng: infoComplejo.longitud,
              }"
              :zoom="15"
              map-type-id="roadmap"
              style="width: 100%; height: 300px"
              :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
              }"
            >
              <GmapMarker
                :position="{
                  lat: infoComplejo.latitud,
                  lng: infoComplejo.longitud,
                }"
                :clickable="true"
                :draggable="false"
              />
            </GmapMap>
          </div>

          <v-list two-line>
            <v-list-item v-if="infoComplejo.nombre">
              <v-list-item-icon>
                <v-icon color="primary">mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-h6">{{
                  infoComplejo.nombre
                }}</v-list-item-title>
                <v-list-item-subtitle>Nombre del Complejo</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="infoComplejo.nombre"></v-divider>

            <v-list-item v-if="infoComplejo.direccion">
              <v-list-item-icon>
                <v-icon color="primary">mdi-map-marker</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  infoComplejo.direccion
                }}</v-list-item-title>
                <v-list-item-subtitle>Dirección</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="infoComplejo.direccion"></v-divider>

            <v-list-item v-if="infoComplejo.celular">
              <v-list-item-icon>
                <v-icon color="primary">mdi-cellphone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  infoComplejo.celular
                }}</v-list-item-title>
                <v-list-item-subtitle>Celular</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="'tel:' + infoComplejo.celular"
                  color="success"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="infoComplejo.celular"></v-divider>

            <v-list-item v-if="infoComplejo.telefono">
              <v-list-item-icon>
                <v-icon color="primary">mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  infoComplejo.telefono
                }}</v-list-item-title>
                <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="'tel:' + infoComplejo.telefono"
                  color="success"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="infoComplejo.telefono"></v-divider>

            <v-list-item v-if="infoComplejo.email">
              <v-list-item-icon>
                <v-icon color="primary">mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ infoComplejo.email }}</v-list-item-title>
                <v-list-item-subtitle>Email</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="'mailto:' + infoComplejo.email"
                  color="primary"
                >
                  <v-icon>mdi-email-send</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="infoComplejo.email"></v-divider>

            <v-list-item v-if="infoComplejo.googleMaps">
              <v-list-item-icon>
                <v-icon color="primary">mdi-google-maps</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Ver en Google Maps</v-list-item-title>
                <v-list-item-subtitle>Ubicación</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="infoComplejo.googleMaps"
                  target="_blank"
                  color="red"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-alert
            v-if="!infoComplejo.nombre && !infoComplejo.direccion"
            type="info"
            text
            class="mt-4"
          >
            No hay información disponible del complejo
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogInfo = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.day-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.day-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.time-chip {
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.time-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.rounded {
  border-radius: 8px;
}

.date-text {
  font-size: 0.875rem;
}

.gap-3 {
  gap: 12px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .time-chip {
    font-size: 0.75rem;
  }

  .date-text {
    font-size: 0.75rem;
  }

  .date-chip {
    height: 28px !important;
  }

  .toolbar-responsive {
    padding: 4px 8px !important;
  }
}

@media (max-width: 400px) {
  .time-chip {
    font-size: 0.7rem;
    padding: 4px 8px;
  }

  .date-text {
    font-size: 0.7rem;
  }

  .date-chip {
    height: 26px !important;
    padding: 0 8px !important;
  }
}

::v-deep .v-dialog {
  overflow-y: auto !important;
}

/* En desktop, prevenir scroll del body cuando el modal está abierto */
@media (min-width: 600px) {
  ::v-deep .v-dialog {
    overflow-y: hidden !important;
  }

  ::v-deep .v-dialog > .v-card {
    overflow-y: auto !important;
    max-height: 90vh !important;
  }
}
</style>

<script>
import axios from "../axios-auth.js";
import moment from "moment";

export default {
  name: "GestionTurnos",
  props: {
    idInstitucion: {
      type: Number,
      required: true,
    },
    idObraSocial: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      date: null,
      dateFormatted: null,
      menu: false,
      listaTurnos: [],
      loading: false,
      sinTurnos: false,
      fechaMinima: this.calcularLunesSemanaActual(),
      fechaMaxima: moment().add(3, "months").format("YYYY-MM-DD"),
      profs: [],
      prof: null,
      isLoading: false,
      dialogInfo: false,
      cargandoInfo: false,
      infoComplejo: null,
      valorTurno: 0,
    };
  },
  computed: {
    turnosPorDia() {
      const grupos = {};

      // Obtener todos los días de la semana actual (Lunes a Domingo)
      const inicioSemana = moment(this.date);
      for (let i = 0; i < 7; i++) {
        const dia = moment(inicioSemana).add(i, "days").format("DD/MM/YYYY");
        grupos[dia] = [];
      }

      // Agrupar turnos por día
      this.listaTurnos.forEach((turno) => {
        const dia = turno.fechaTurnoString;
        if (grupos[dia]) {
          grupos[dia].push(turno);
        }
      });

      // Convertir a array y ordenar para que Lunes sea primero
      const gruposArray = Object.entries(grupos);
      gruposArray.sort((a, b) => {
        const [dA, mA, yA] = a[0].split("/");
        const [dB, mB, yB] = b[0].split("/");
        const dateA = new Date(yA, mA - 1, dA);
        const dateB = new Date(yB, mB - 1, dB);
        return dateA - dateB;
      });

      // Convertir de vuelta a objeto
      const gruposOrdenados = {};
      gruposArray.forEach(([dia, turnos]) => {
        gruposOrdenados[dia] = turnos;
      });

      return gruposOrdenados;
    },
    puedeRetroceder() {
      // Verificar si retroceder una semana nos llevaría antes de la fecha mínima
      const semanaAnterior = moment(this.date).subtract(7, "days");
      return semanaAnterior.isSameOrAfter(moment(this.fechaMinima));
    },
  },
  mounted() {
    this.buscarCanchas();
  },
  watch: {
    date(newDate) {
      if (newDate) {
        this.dateFormatted = moment(newDate).format("DD/MM/YYYY");
      }
    },
  },
  methods: {
    calcularLunesSemanaActual() {
      const hoy = moment();
      const diaSemana = hoy.day(); // 0=Domingo, 1=Lunes, etc.
      const diasARestar = diaSemana === 0 ? 6 : diaSemana - 1;
      return hoy.subtract(diasARestar, "days").format("YYYY-MM-DD");
    },
    async buscarCanchas() {
      const filtrosData = {
        idInstitucion: this.idInstitucion,
      };
      try {
        const { data: canchas } = await axios.get("/PortalPublico/GetCanchas", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
          },
        });
        if (canchas != null && canchas != "") this.profs = canchas;
        else this.profs = [];
        if (this.profs.length) {
          this.prof = this.profs[0].idCancha;
          await this.buscarValorTurno();
          this.buscarPrimeraSemanaConTurnos();
        }
      } catch (error) {
        this.profs = [];
      }
    },
    async buscarValorTurno() {
      try {
        const { data } = await axios.get("/PortalPublico/BuscarValorTurnoWeb", {
          params: {
            idInstitucion: this.idInstitucion,
          },
        });
        this.valorTurno = parseFloat(data) || 0;
      } catch (error) {
        console.error("Error al buscar valor del turno:", error);
        this.valorTurno = 0;
      }
    },
    onCanchaChange() {
      if (this.prof) {
        this.buscarPrimeraSemanaConTurnos();
      }
    },
    setToday() {
      const hoy = new Date().getDay();
      const diasARestar = hoy === 0 ? 6 : hoy - 1;
      const dias = 1000 * 60 * 60 * 24 * diasARestar;
      const resta = new Date().getTime() - dias;
      this.date = moment(resta).format("YYYY-MM-DD");
      this.dateFormatted = moment(resta).format("DD/MM/YYYY");
    },
    getDiaSemana(fechaStr) {
      const [d, m, y] = fechaStr.split("/");
      const date = new Date(y, m - 1, d);
      const dias = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      return dias[date.getDay()];
    },
    retrocederSemana() {
      this.date = moment(this.date).subtract(7, "days").format("YYYY-MM-DD");
      this.cargarTurnos();
    },
    avanzarSemana() {
      this.date = moment(this.date).add(7, "days").format("YYYY-MM-DD");
      this.cargarTurnos();
    },
    allowedDates(val) {
      // Usar moment para evitar problemas de zona horaria
      // getDay() retorna: 0=Domingo, 1=Lunes, 2=Martes, etc.
      return moment(val).day() === 1; // Solo lunes
    },
    async buscarPrimeraSemanaConTurnos() {
      if (!this.prof) return;

      this.loading = true;
      this.sinTurnos = false;
      this.setToday();

      let fechaActual = moment(this.date);
      const fechaLimite = moment(this.fechaMaxima);

      while (fechaActual.isSameOrBefore(fechaLimite)) {
        try {
          const response = await axios.get(
            "/PortalPublico/ArmarTurnosSemanaPortalOptimizado",
            {
              params: {
                idProfesional: this.prof,
                fecha: fechaActual.format("YYYY-MM-DD"),
                idInstitucion: this.idInstitucion,
              },
            },
          );

          const turnosDisponibles = response.data.filter(
            (turno) => turno.paciente === "Disponible",
          );

          if (turnosDisponibles.length > 0) {
            this.date = fechaActual.format("YYYY-MM-DD");
            this.dateFormatted = fechaActual.format("DD/MM/YYYY");
            this.listaTurnos = turnosDisponibles;
            this.loading = false;
            return;
          }

          // Avanzar una semana
          fechaActual.add(7, "days");
        } catch (error) {
          console.error("Error al buscar turnos:", error);
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Error al cargar turnos",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
      }

      // No se encontraron turnos en todo el período
      this.sinTurnos = true;
      this.loading = false;
    },
    cargarTurnos() {
      if (!this.prof) return;

      this.loading = true;
      axios
        .get("/PortalPublico/ArmarTurnosSemanaPortalOptimizado", {
          params: {
            idProfesional: this.prof,
            fecha: this.date,
            idInstitucion: this.idInstitucion,
          },
        })
        .then((response) => {
          this.listaTurnos = response.data.filter(
            (turno) => turno.paciente === "Disponible",
          );
        })
        .catch((error) => {
          console.error("Error al cargar turnos:", error);
          this.$swal.fire({
            icon: "error",
            title: "Error al cargar turnos",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccionarTurno(turno) {
      this.$emit("turnoSeleccionado", { turno, idCancha: this.prof });
    },
    async mostrarInfoComplejo() {
      this.dialogInfo = true;
      this.cargandoInfo = true;

      try {
        const { data } = await axios.get(
          "/PortalPublico/BuscarDatosInstitucion",
          {
            params: {
              idInstitucion: this.idInstitucion,
            },
          },
        );

        this.infoComplejo = {
          nombre: data.nombreInstitucion || this.$store.state.nombreInstitucion,
          direccion: data.direccion,
          celular: data.celular,
          telefono: data.telefono,
          email: data.email,
          googleMaps: data.googleMaps || data.direccionGoogleMaps,
          latitud: parseFloat(data.latitud),
          longitud: parseFloat(data.longitud),
        };
      } catch (error) {
        console.error("Error al cargar información del complejo:", error);
        this.infoComplejo = {
          nombre: this.$store.state.nombreInstitucion,
        };
      } finally {
        this.cargandoInfo = false;
      }
    },
  },
};
</script>
